<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">聊天内容</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>VIP：</label>
          <el-select v-model="vipState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in vipStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>IP状态：</label>
          <el-select v-model="ipState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in ipStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>审查状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>屏蔽状态：</label>
          <el-select v-model="screenState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in screenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>关键词：</label>
          <el-select v-model="blockContent" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in blockContentArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>封号：</label>
          <el-select v-model="forbiddenState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in forbiddenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <el-select v-model="userTimeType" placeholder="Select" style="width: 7.6em; margin-right: 4px;">
            <el-option v-for="item in userTimeTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <DatePickerRange title="" @date="getRegTime($event)" @check="getRegCheck($event)" :isChecked="isRegChecked" :disable="isRegDisable"/>
        </div>
        <div class="content-input-item">
          <el-select v-model="interactTimeType" placeholder="Select" style="width: 9em; margin-right: 4px;">
            <el-option v-for="item in interactTimeTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <DatePickerRange title="" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked" :disable="isDisable"/>
        </div>
        <div class="content-input-item">
          <DatePickerRange_30 title="发送时间：" @date="getSendTime($event)" @check="getSendCheck($event)" :isChecked="searchType != 4"/>
        </div>
        <div class="content-input-item">
          <label>关注类型：</label>
          <el-select v-model="focusState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in focusStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" v-loading="updateLoading" @click="updateInteract">标为已审查</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
            @sort-change="sortChange"
        >
          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="106">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth"/>
              <p>信息状态：{{scope.row.resumeState == 0 ? "未提交" : scope.row.resumeState == 1 ? "待审核" : scope.row.resumeState == 2 ? "已通过" : scope.row.resumeState == 3 ? "不通过" : "--"}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="注册/进入时间" v-if="checkColList.indexOf('注册/进入时间') > -1" width="150">
            <template #default="scope">
              <p>注册：{{scope.row.regTime}}</p>
              <p>进入：{{scope.row.enterTime}}</p>
            </template>
          </el-table-column>
          <el-table-column property="chatTime" label="最新IM时间" v-if="checkColList.indexOf('最新IM时间') > -1" width="130" sortable='custom'/>
          <el-table-column property="chatNum" label="聊天人数" v-if="checkColList.indexOf('聊天人数') > -1" class-name="cursor" sortable='custom' width="110">
            <template #default="scope">
              <span style="color: #409eff">{{ scope.row.chatNum}}</span>
            </template>
          </el-table-column>
          <el-table-column property="chatViolationNum" label="聊天违规人数" v-if="checkColList.indexOf('聊天违规人数') > -1" class-name="cursor" width="140" sortable='custom'>
            <template #default="scope">
              <span style="color: #409eff">{{ scope.row.chatViolationNum}}</span>
            </template>
          </el-table-column>
          <el-table-column property="msgTime" label="最新纸条时间" v-if="checkColList.indexOf('最新纸条时间') > -1" width="136" sortable='custom'/>
          <el-table-column property="msgNum" label="纸条人数" v-if="checkColList.indexOf('纸条人数') > -1" class-name="cursor" sortable='custom' width="110">
            <template #default="scope">
              <span style="color: #409eff">{{ scope.row.msgNum}}</span>
            </template>
          </el-table-column>
          <el-table-column property="msgViolationNum" label="纸条违规人数" v-if="checkColList.indexOf('纸条违规人数') > -1" width="140" class-name="cursor" sortable='custom'>
            <template #default="scope">
              <span style="color: #409eff">{{ scope.row.msgViolationNum}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1" class-name="cursor" width="120">
            <template #default="scope">
              {{scope.row.state == 0?'未审查':scope.row.state == 1?'已审查':''}}
              <p v-if="scope.row.screenState == 1" style="color: red">已屏蔽</p>
              <p v-if="scope.row.isBannedChat" style="color: red">已禁言</p>
              <p v-if="scope.row.isForbidden" style="color: red">已封号</p>
              <p v-if="scope.row.isDel" style="color: red">已隐藏</p>
              <p :style="{color:scope.row.focusState > 3?'red':'#aaaaaa' }">{{
                  scope.row.focusState == 0?'未关注':
                  scope.row.focusState == 1?"已关注":
                  scope.row.focusState == 2?"自动取消关注":
                  scope.row.focusState == 3?"手动取消关注":
                  scope.row.focusState == 4?"已关注-封号":
                  scope.row.focusState == 5?"已关注-手动":
                  scope.row.focusState == 6?"已关注-设备异常":
                  scope.row.focusState == 7?"已关注-IP异常":
                  scope.row.focusState == 8?"已关注-订单异常":
                  scope.row.focusState == 9?"已关注-省份不一致":""
                }}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" class-name="cursor" width="110">
            <template #default="scope">
<!--              <el-space direction="vertical" alignment="left">-->
<!--&lt;!&ndash;                <el-button type="primary" size="small" @click="appointAuth(scope.row)">指定认证</el-button>&ndash;&gt;-->
<!--                <AppointAuth :row="scope.row" />-->
<!--                <el-button v-if="!scope.row.isBannedChat" type="primary" size="small" @click="updateBannedChat(scope.$index, scope.row, 1)">禁言</el-button>-->
<!--                <el-button v-if="scope.row.isBannedChat" type="success" size="small" @click="updateBannedChat(scope.$index, scope.row, 2)" v-loading="scope.row['bannedLoading']">解除禁言</el-button>-->
<!--                <el-button v-if="scope.row.screenState == 0" type="primary" size="small" @click="updateScreenState(scope.$index, scope.row, 1)" v-loading="scope.row['screenLoading']">屏蔽</el-button>-->
<!--                <el-button v-if="scope.row.screenState == 1" type="success" size="small" @click="updateScreenState(scope.$index, scope.row, 0)" v-loading="scope.row['screenLoading']">取消屏蔽</el-button>-->
<!--                <el-button v-if="!scope.row.isForbidden" type="primary" size="small" @click="updateUserForbidden(scope.$index, scope.row, 1)" v-loading="scope.row['forbiddenLoading']">封号</el-button>-->
<!--                <el-button v-if="scope.row.isForbidden" type="success" size="small" @click="updateUserForbidden(scope.$index, scope.row, 2)" v-loading="scope.row['forbiddenLoading']">解除封号</el-button>-->
<!--              </el-space>-->
              <ActionButton :row="scope.row" showList="hide,forbidden,chat,screen,point,focus"/>
              <el-button type="danger" size="small" @click="batchReject(scope.$index, scope.row.userId)">信息不通过</el-button>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import DatePickerRange_30 from '../../components/DatePickerRange_30_noLimit'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import { getChatContentPageList, listBlockRuleSpecial, updateInteractState, updateUserBannedChat, updateScreenState, updateUserForbidden } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import ChatUserList from "./components/content/ChatUserList"
import MsgUserList from "./components/content/MsgUserList"
import BannedChatDialog from "@/components/resume/BannedChatDialog";
import ForbiddenDialog from '@/components/resume/ForbiddenDialog'
// import ipCityAbnormalDialog from '@/components/resume/ipCityAbnormalDialog'
// import AppointAuthDialog from "@/components/resume/AppointAuthDialog";
import AppointAuth from "@/components/resume/AppointAuth";
import ActionButton from "@/components/resume/ActionButton";
import resumeRejectDialog from "@/views/review/components/resume/resumeRejectDialog";

export default {
  name: "ChatContent",
  components: { DatePickerRange, SearchComponents, UserLog, AppointAuth, ActionButton, DatePickerRange_30 },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      vipStateArray: [
        {label: '不限', value: -1},
        {label: '未开通', value: 1},
        {label: '已开通', value: 2},
        {label: '已过期', value: 3},
      ],
      vipState: -1,

      ipStateArray: [
        {label: '不限', value: -1},
        {label: '正常', value: 0},
        {label: '异常', value: 1},
        {label: '异常变正常', value: 2},
      ],
      ipState: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '未审查', value: 0},
        {label: '已审查', value: 1},
      ],
      state: -1,

      screenStateArray: [
        {label: '不限', value: -1},
        {label: '正常', value: 0},
        {label: '已屏蔽', value: 1},
      ],
      screenState: -1,

      forbiddenStateArray: [
        {label: '不限', value: -1},
        {label: '未封号', value: 0},
        {label: '已封号', value: 1},
      ],
      forbiddenState: 0,

      blockContentArray: [
        {label: '不限', value: ''}
      ],
      blockContent: '',

      userTimeTypeArray: [
        {label: '进入时间', value: 1},
        {label: '注册时间', value: 2}
      ],
      userTimeType: 1,

      interactTimeTypeArray: [
        {label: '最新IM时间', value: 1},
        {label: '最新纸条时间', value: 2}
      ],
      interactTimeType: 1,

      //关注类型
      focusStateArray: [
        {label: '不限', value: -1},
        {label: '未关注', value: 0},
        {label: '已关注', value: 1},
        {label: '自动取消关注', value: 2},
        {label: '手动取消关注', value: 3},
        {label: '已关注-封号', value: 4},
        {label: '已关注-手动', value: 5},
        {label: '已关注-设备异常', value: 6},
        {label: '已关注-IP异常', value: 7},
        {label: '已关注-订单异常', value: 8},
        {label: '已关注-省份不一致', value: 9},
      ],
      focusState: 1,

      //IM/纸条时间
      startTime: '',
      endTime: '',
      isChecked: false,
      isDisable: false,

      //注册/进入时间
      userStartTime: '',
      userEndTime: '',
      isRegChecked: true,
      isRegDisable: false,

      //发送时间
      sendStartTime: '',
      sendEndTime: '',
      isSendChecked: false,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '聊天内容', value : 4},
      ],
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['头像', '用户信息', '注册/进入时间', '最新IM时间', '聊天人数', '聊天违规人数', '最新纸条时间', '纸条人数', '纸条违规人数', '状态', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,

      sort: 1,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getRegTime(val) {
      this.userStartTime = val[0];
      this.userEndTime = val[1];
      // console.log(val)
    },
    getRegCheck(val) {
      this.isRegChecked = val
    },

    getSendTime(val) {
      this.sendStartTime = val[0];
      this.sendEndTime = val[1];
      // console.log(val)
    },
    getSendCheck(val) {
      this.isSendChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      if(e == 4) {
        this.isRegChecked = true
        this.isChecked = true
        this.isRegDisable = true
        this.isDisable = true
      }else {
        this.isRegDisable = false
        this.isDisable = false
      }
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.isRegChecked = true;
      this.isSendChecked = true;
      this.sex = -1;
      this.vipState = -1;
      this.ipState = -1;
      this.state = -1;
      this.screenState = -1;
      this.forbiddenState = -1;
      this.userTimeType = 1;
      this.interactTimeType = 1;
      this.blockContent = '';
      this.searchValue = '';
      this.sort = 1;
      this.focusState = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    sortChange(column) {
      if(column.prop == 'chatTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'chatNum') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      } else if(column.prop == 'chatViolationNum') {
        if(column.order == 'descending') {
          this.sort = 5;
        } else if(column.order == 'ascending') {
          this.sort = 6;
        }
      } else if(column.prop == 'msgTime') {
        if(column.order == 'descending') {
          this.sort = 7;
        } else if(column.order == 'ascending') {
          this.sort = 8;
        }
      } else if(column.prop == 'msgNum') {
        if(column.order == 'descending') {
          this.sort = 9;
        } else if(column.order == 'ascending') {
          this.sort = 10;
        }
      } else if(column.prop == 'msgViolationNum') {
        if(column.order == 'descending') {
          this.sort = 11;
        } else if(column.order == 'ascending') {
          this.sort = 12;
        }
      }
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['vipState'] = this.vipState;
      param['ipState'] = this.ipState;
      param['state'] = this.state;
      param['screenState'] = this.screenState;
      param['blockContent'] = this.blockContent;
      param['userTimeType'] = this.userTimeType;
      param['interactTimeType'] = this.interactTimeType;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['userStartTime'] = this.userStartTime;
      param['userEndTime'] = this.userEndTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['forbiddenState'] = this.forbiddenState;
      param['sort'] = this.sort;
      param['focusState'] = this.focusState;
      if(this.searchType == 4) {
        param['sendStartTime'] = this.sendStartTime;
        param['sendEndTime'] = this.sendEndTime;
      }
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getChatContentPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //聊天人数
      if(column.label == '聊天人数') {
        Dialog.open({
          title: '聊天人数列表',
          component: ChatUserList,
          data: {
            id: row.userId,
            violationState: -1,
            blockContentArray: this.blockContentArray,
            width: '1100px'
          },
          close: () => {

          }
        })
      }

      //聊天违规人数
      if(column.label == '聊天违规人数') {
        Dialog.open({
          title: '聊天违规人数列表',
          component: ChatUserList,
          data: {
            id: row.userId,
            violationState: 1,
            blockContentArray: this.blockContentArray,
            width: '1100px'
          },
          close: () => {

          }
        })
      }

      //纸条人数
      if(column.label == '纸条人数') {
        Dialog.open({
          title: '纸条人数列表',
          component: MsgUserList,
          data: {
            id: row.userId,
            violationState: -1,
            blockContentArray: this.blockContentArray,
            width: '1100px'
          },
          close: () => {

          }
        })
      }

      //聊天违规人数
      if(column.label == '纸条违规人数') {
        Dialog.open({
          title: '纸条违规人数列表',
          component: MsgUserList,
          data: {
            id: row.userId,
            violationState: 1,
            blockContentArray: this.blockContentArray,
            width: '1100px'
          },
          close: () => {

          }
        })
      }


    },

    //获取关键词列表
    getSpecialList() {
      getFormData(listBlockRuleSpecial).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          result.map(item => {
            let obj = {};
            obj.label = item;
            obj.value = item;
            this.blockContentArray.push(obj)
          })
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    //审查
    updateInteract() {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量标为已审查？').then(()=>{
          this.updateLoading = true;
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray;
          postFormData(updateInteractState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }
            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.updateLoading = false;
          })
              .catch(()=>{
                _this.updateLoading = false;
              })
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    //单个禁言/解除
    updateBannedChat(idx, row, state) {
      let userIdArr = [];
      userIdArr.push(row.userId);
      if(state == 1) {
        Dialog.open({
          title: '禁言时间',
          component: BannedChatDialog,
          data: {
            userIdArray: userIdArr,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }else if (state == 2) {
        this.$confirm('确定对用户【'+ row.nickName + '】解除禁言？')
            .then(() => {
              this.pageDataList[idx]['bannedLoading'] = true
              let param = {}
              param['idArr'] = userIdArr
              param['state'] = 2
              param['day'] = 0
              postFormData(updateUserBannedChat, param).then((data) => {
                let {code, msg} = data;
                if ( code == 200 ) {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'success'
                  })
                  this.pageDataList[idx]['isBannedChat'] = false
                } else {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'warning'
                  })
                }
                this.pageDataList[idx]['bannedLoading'] = false
              }).catch(()=>{
                this.pageDataList[idx]['bannedLoading'] = false
              })
            })
            .catch(() => {
              // catch error
            })
      }
    },

    //更新屏蔽状态
    updateScreenState(idx, row, state) {
      this.$confirm('确定' + (state==1?'【屏蔽】用户':'【取消屏蔽】用户') +'【' + row.nickName + '】?').then(()=>{
        this.pageDataList[idx]['screenLoading'] = true
        let param = {}
        param['id'] = row.userId
        param['screenState'] = state
        postFormData(updateScreenState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList[idx]['screenState'] = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['screenLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['screenLoading'] = false
        })
      })
    },

    //更新封号状态
    updateUserForbidden(idx, row, state) {
      if(state == 1) {
        Dialog.open({
          title: '确定对用户【' + row.nickName + '】封号？',
          component: ForbiddenDialog,
          data: {
            userId: row.userId,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      } else if(state == 2) {
        this.$confirm('确定【取消封号】用户' +'【' + row.nickName + '】?').then(()=>{
          this.pageDataList[idx]['forbiddenLoading'] = true
          let param = {}
          param['id'] = row.userId
          param['state'] = state
          param['type'] = 99
          param['idfaBanState'] = 0
          postFormData(updateUserForbidden, param).then((data)=>{
            let {code, msg} = data
            if(code == 200) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
              this.pageDataList[idx]['isForbidden'] = false
            }else {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            this.pageDataList[idx]['forbiddenLoading'] = false
          }).catch(()=>{
            this.pageDataList[idx]['forbiddenLoading'] = false
          })
        })
      }
    },

    // //用户异常ip列表
    // openIpCityDialog(idx, row) {
    //   Dialog.open({
    //     title: '用户【' + row.nickName + '】异常ip列表',
    //     component: ipCityAbnormalDialog,
    //     data: {
    //       id: row.userId,
    //       width: '600px',
    //       ipState: row.ipState,
    //     },
    //     confirm: (result) => {
    //       this.pageDataList[idx]['ipState'] = result.state
    //     }
    //   })
    // },

    // // 指定认证
    // appointAuth(row) {
    //   Dialog.open({
    //     title: '指定用户【'+ row.nickName +'】去认证？',
    //     component: AppointAuthDialog,
    //     data: {
    //       identity: row.recheckAuthIdentity,
    //       zhima: row.recheckAuthZhima,
    //       video: row.recheckAuthVideo,
    //       identityState: row.identityAuth.identityState,
    //       baiduState: row.identityAuth.baiduState,
    //       zhimaCertifyState: row.identityAuth.zhimaState,
    //       videoState: row.authVideo?row.authVideo.state:'',
    //       cancelVideoAuth: row.cancelVideoAuth,
    //       cancelIdentityAuth: row.cancelIdentityAuth,
    //       cancelZhimaAuth: row.cancelZhimaAuth,
    //       userId: row.userId,
    //       width: '400px'
    //     },
    //     confirm: (result) => {
    //       if(result.type == 1) {
    //         row.cancelIdentityAuth = result.state;
    //       } else if(result.type == 2) {
    //         row.cancelZhimaAuth = result.state;
    //       } else if(result.type == 3) {
    //         row.cancelVideoAuth = result.state;
    //       } else {
    //         row.recheckAuthIdentity = result.recheckAuthIdentity;
    //         row.recheckAuthZhima = result.recheckAuthZhima;
    //         row.recheckAuthVideo = result.recheckAuthVideo;
    //       }
    //     }
    //   })
    // },

    batchReject(idx, userId) {
      let _title = '信息不通过原因'
      let _this = this
      let arr = []
      arr.push(userId)
      Dialog.open({
        title: _title,
        component: resumeRejectDialog,
        data: {
          idArray: arr,
          width: '500px',
        },
        confirm: (()=>{
          _this.pageDataList.splice(idx, 1)
        })
      })
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getSpecialList();
  }
}
</script>

<style scoped>

</style>
